import { createStore } from '@servicetitan/financing-utils-shared';
import { useState, useCallback } from 'react';

export interface DisclosureState {
    agreedToDisclosures: boolean;
    applicantSignature: string | null;
    coApplicantSignature: string | null;
}

function useDisclosureData(initialState: boolean = false) {
    const [disclosureState, setDisclosureState] = useState<DisclosureState>({
        agreedToDisclosures: initialState,
        applicantSignature: null,
        coApplicantSignature: null,
    });

    const setAgreedToDisclosures = useCallback((attested: boolean) => {
        setDisclosureState(prev => ({
            ...prev,
            agreedToDisclosures: attested,
        }));
    }, []);

    const setApplicantSignature = useCallback((base64Signature: string | null) => {
        setDisclosureState(prev => ({
            ...prev,
            applicantSignature: base64Signature,
        }));
    }, []);

    const setCoApplicantSignature = useCallback((base64Signature: string | null) => {
        setDisclosureState(prev => ({
            ...prev,
            coApplicantSignature: base64Signature,
        }));
    }, []);

    const resetDisclosureState = useCallback(() => {
        setDisclosureState({
            agreedToDisclosures: false,
            applicantSignature: null,
            coApplicantSignature: null,
        });
    }, []);

    return {
        disclosureState,
        setAgreedToDisclosures,
        setApplicantSignature,
        setCoApplicantSignature,
        resetDisclosureState,
    };
}

export const DisclosureDataStore = createStore(useDisclosureData);

export type DisclosureDataStore = ReturnType<typeof useDisclosureData>;
